import CertificatType from "../../../Types/CertificatType";

const Certificat = ({
  name,
  description,
  img,
  className = "getCertificatBox",
  callback
}: CertificatType) => {
  return (
    <div className="getCertificat">
      <div className={className} onClick={callback}>
        <div className="certificatImage">
          <img src={img} alt="" />
        </div>
        <div className="certtificatContent">
          <h2>{name}</h2>
          <div className="certificatDescription">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default Certificat;
